angular.module('lsnBase.filters')
  .filter('addDays', function(){
    return function(input, numDays) {
      if(typeof input === 'undefined' || input === '' || !(new XDate(input).valid())){
        return input;
      }
      return new XDate(input).addDays(numDays).toString('yyyy-MM-dd');
    };
});